import { cn } from '@/new/lib/utils';

interface BetaBadgeProps {
  className?: string;
}

export function BetaBadge({ className }: BetaBadgeProps) {
  return (
    <div
      className={cn(
        'rounded-full border border-teal-300 bg-teal-50 px-1.25 pt-0.25 text-[9px] font-bold text-teal-500',
        className,
      )}
    >
      BETA
    </div>
  );
}
